/**
* @brandOverride URBNWeb
*/
// import {
//     init as productMessagesInit
// } from './productMessagesComponent';
import {
    init as productRegistryInit
} from './productRegistryComponent';
import {
    init as productRegistryMultipleInit
} from './productRegistryMultipleComponent';

export const familyProductComponentConfigOverride = {
    children: [
        [productRegistryInit, {
            templateLocation: '.dom-add-to-registry',
            name: 'familyProductRegistryComponent',
            forFamilyProduct: true
        }],
        [productRegistryMultipleInit, {
            templateLocation: '.dom-registry-list',
            name: 'familyProductRegistryMultipleComponent',
            forFamilyProduct: true
        }]
    ]
};
